import React from 'react';

import Icon from '../Icon/Icon';

const TickCircle = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M24 7C33.3888 7 41 14.6112 41 24C41 33.3888 33.3888 41 24 41C14.6112 41 7 33.3888 7 24C7 14.6112 14.6112 7 24 7Z'
                fill='#393E44'
                stroke='#00D1D2'
                strokeWidth='2'
            />
            <path
                d='M17.25 24.375L22.5803 29.7214L31.5 18.75'
                stroke='#FFFDFB'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default TickCircle;
